import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NbRangepickerComponent } from '@nebular/theme/components/datepicker/datepicker.component';
import { NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap/accordion/accordion';
import * as moment from 'moment';
import { DaterangepickerComponent, DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { CountryISO, SearchCountryField, TooltipLabel } from 'ngx-intl-tel-input';
import { Observable } from 'rxjs/Observable';
import { Filter } from '../../../../shared/constants/Filters';
import { LeadsFilterLocalStorageDto } from '../../../../shared/models/common/filters/leadsFilterLocalStorage.dto';
import { DashboardFilter } from '../../../../shared/models/company/dashboardFilter';
import { LeadFilter } from '../../../../shared/models/lead/leadFilter';
import { TranslatorService } from '../../../../shared/services/utils/translator.service';
import { LeadsComunicationService } from '../../../leads/leads-comunication.service';
import { BrandSelectionDropdownComponent } from '../../dropdown/brand-selection-dropdown/brand-selection-dropdown.component';
import { ChannelSelectionDropdownComponent } from '../../dropdown/channel-selection-dropdown/channel-selection-dropdown.component';
import { CompanySelectionDropdownComponent } from '../../dropdown/company-selection-dropdown/company-selection-dropdown.component';
import { DealerSelectionDropdownComponent } from '../../dropdown/dealer-selection-dropdown/dealer-selection-dropdown.component';
import { OriginSelectionDropdownComponent } from '../../dropdown/origin-selection-dropdown/origin-selection-dropdown.component';
import { TypeSelectionDropdownComponent } from '../../dropdown/type-selection-dropdown/type-selection-dropdown.component';
import { UserSelectionByRoleDropdownComponent } from '../../dropdown/user-selection-by-role-dropdown/user-selection-by-role-dropdown.component';
import { CsvGeneratorService } from '../../../../shared/services/csv-generation/csv-generator.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ModalsHandlerService } from '../../../../pages/modals/modals.handler.service';
import { AuthService } from '../../../../shared/services/security/auth.service';
import { RolType } from '../../../../shared/models/types/rol.types';

@Component({
  selector: 'ngx-leads-filter',
  templateUrl: './leads-filter.component.html',
  styleUrls: ['./leads-filter.component.scss'],
  styles: [
    `
      @media only screen and (max-width: 991px) {
        :host ::ng-deep ngx-daterangepicker-material {
          right: 50vw;
        }
      }

      @media only screen and (max-width: 480px) {
        :host ::ng-deep ngx-daterangepicker-material {
          right: 75vw;
        }
      }

      :host ::ng-deep ngx-daterangepicker-material {
        position: absolute;
      }

      :host ::ng-deep .calendar.right {
        display: none !important;
      }
    `,
  ],
})
export class LeadsFilterComponent implements OnInit, OnDestroy, AfterViewInit {
  archivedNotContacted: boolean;
  archivedNotInterested: boolean;
  archivedOther: boolean;
  archivedByPrice: boolean;
  archivedByAppraisal: boolean;
  archivedByFinancing: boolean;
  archivedImmature: boolean;
  archivedSameBrand: boolean;
  archivedAnotherBrand: boolean;
  archivedSameBrandDealership: boolean;
  archivedAnotherBrandDealership: boolean;
  rangeCreate: { start: Date; end: Date };
  rangeUpdate: { start: Date; end: Date };
  rangeVisit: { start: Date; end: Date };
  rangeReminder: { start: Date; end: Date };
  reloadLeadSubcribe: any;
  phoneNormalized: any;
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  TooltipLabel = TooltipLabel;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [CountryISO.Spain, CountryISO.Portugal];
  phoneForm = new FormGroup({
    phone: new FormControl(undefined, [])
  });
  closeDateRange: { start: Date; end: Date; };
  archivedDateRange: { start: Date; end: Date; };
  Filter = Filter;
  @Input() filterName: string;
  @Input() withoutCard = false;
  @Input() hideHeaderActions = false;

  get haveFiltersApplied(): any {
    return Boolean(
      this.filterNewLead ||
      this.filterReminders ||
      this.filterVisits ||
      this.visitStatus ||
      this.filterContacteds ||
      this.filterTransfereds ||
      this.filterPrequalification ||
      this.filter.descriptionModel ||
      this.filter.leadContact ||
      this.filter.postalCode ||
      this.isStatusFilterSelected() ||
      this.isDateFilterSelected() ||
      this.isDateUpdateFilterSelected() ||
      this.isDateReminderFilterSelected() ||
      this.isDateVisitFilterSelected() ||
      this.isDropdownElementFilterSelected() ||
      this.contactStatus ||
      this.filterOnCall ||
      this.isScoringRangeFilterSelected()
    );
  }

  filter: LeadFilter | DashboardFilter;
  channelSelected: any;
  companySelected: any;
  brandsSelected: any;
  dealersSelected: any;
  usersSelected: any;
  typesSelected: any;
  originSelected: any;
  @ViewChild(UserSelectionByRoleDropdownComponent, { static: false })
  userSelectionComponent: UserSelectionByRoleDropdownComponent;
  @ViewChild(CompanySelectionDropdownComponent, { static: false })
  companiesSelectionComponent: CompanySelectionDropdownComponent;
  @ViewChild(BrandSelectionDropdownComponent, { static: false })
  brandSelectionComponent: BrandSelectionDropdownComponent;
  @ViewChild(ChannelSelectionDropdownComponent, { static: false })
  channelSelectionComponent: ChannelSelectionDropdownComponent;
  @ViewChild(DealerSelectionDropdownComponent, { static: false })
  dealerSelectionComponent: DealerSelectionDropdownComponent;
  @ViewChild(TypeSelectionDropdownComponent, { static: false })
  typesSelectionComponent: TypeSelectionDropdownComponent;
  @ViewChild(OriginSelectionDropdownComponent, { static: false })
  originSelectionComponent: OriginSelectionDropdownComponent;

  @ViewChild(NbRangepickerComponent, { static: false })
  createDatePicker: NbRangepickerComponent<Date>;
  @ViewChild(NbRangepickerComponent, { static: false })
  updatedDatePicker: NbRangepickerComponent<Date>;
  @ViewChild(NbRangepickerComponent, { static: false })
  reminderDate: NbRangepickerComponent<Date>;
  @ViewChild(NbRangepickerComponent, { static: false })
  visitDate: NbRangepickerComponent<Date>;

  @ViewChild(DaterangepickerDirective, { static: false })
  pickerDirective: DaterangepickerDirective;

  picker: DaterangepickerComponent;

  filterDate: string;
  filterDateUpdate: string;
  today = moment();
  createdAtFrom: Date;
  createdAtTo: Date;
  updatedAtFrom: Date;
  updatedAtTo: Date;
  filterOnTrackCold: boolean;
  filterOnTrackWarm: boolean;
  filterOnTrackHot: boolean;
  filterNewLead: boolean;
  filterClosed = false;
  filterArchived: boolean;
  rangeSelected: string;
  dateModel: string;
  datePresetSelected: string = '';
  rangeUpdatedSelected: string;
  dateUpdateModel: string;
  dateUpdatePresetSelected: string = '';
  state$: Observable<object>;
  descriptionModel: any;
  scoringFrom: number;
  scoringTo: number;
  scoringNull: boolean;
  contactFilterInputType: string;
  postalCodeFilterInputType: string;

  filterReminders = false;
  filterVisits = false;
  filterTransfereds = false;
  filterContacteds = false;

  visitStatus = null;

  visitFilterGroupActive = true;

  checkContactFilter = true;
  checkPostalCodeFilter = true;
  sending = false;
  customFilterSubcribe: any;
  drawFinished = false;
  changedBetweenViewsSubscribe: any;

  contactStatus: string;
  filterNotContacteds = false;
  filterOnCall = false;
  filterPrequalification = false;
  leadsOrderField = 'lead.createdAt';
  leadsOrderBy = 'DESC';
  showGridIcon = true;

  noReportTranslationToken: string;
  notComeTranslationToken: string;
  yesComeTranslationToken: string;
  language: string;
  restrictCssForLanguages = ['fr'];
  isRestricted: boolean;
  rolType: RolType = new RolType();

  constructor(
    private readonly leadComunicationService: LeadsComunicationService,
    private readonly route: ActivatedRoute,
    private readonly translationService: TranslatorService,
    private readonly csvService: CsvGeneratorService,
    private readonly deviceDetector: DeviceDetectorService,
    private readonly modalsHandler: ModalsHandlerService,
    readonly authService: AuthService,
  ) {
    this.language = translationService.getLanguage();
    this.isRestricted = this.restrictCssForLanguages.includes(this.language);
    this.closeDateRange = { start: null, end: null };
    this.rangeCreate = { start: null, end: null };
    this.rangeUpdate = { start: null, end: null };
    this.rangeVisit = { start: null, end: null };
    this.rangeReminder = { start: null, end: null };
    this.archivedDateRange = { start: null, end: null };
    if (this.filterName === Filter.NEW_DASHBOARD || this.filterName === Filter.DASHBOARD) {
      this.filter = new DashboardFilter();
    }
    if (this.filterName !== Filter.NEW_DASHBOARD && this.filterName !== Filter.DASHBOARD) {
      this.filter = new LeadFilter();
    }
  }

  ngOnDestroy(): void {
    if (this.changedBetweenViewsSubscribe) {
      this.changedBetweenViewsSubscribe.unsubscribe();
    }
    this.customFilterSubcribe.unsubscribe();
    this.reloadLeadSubcribe.unsubscribe();
  }

  ngOnInit(): void {
    const storedView = localStorage.getItem('viewCards');
    if (storedView !== null) {
      this.showGridIcon = JSON.parse(storedView);
    }
    this.changedBetweenViewsSubscribe = this.leadComunicationService.changedBetweenViews.subscribe(() => {
      const updatedStoredView = localStorage.getItem('viewCards');
      if (updatedStoredView !== null) {
        this.showGridIcon = !JSON.parse(updatedStoredView);
      }
    });

    this.route.queryParams.subscribe((params) => {
      if (params.fromNotification) {
        this.clearFilter();
        this.filterNewLead = true;
        this.usersSelected = [];
        this.usersSelected.push({
          id: '',
          name: this.translationService.trans('pages.leads.type.unknow'),
        });
      }
      if (params.fromNotificationReminder) {
        this.clearFilter();
        this.filter.customFilters = ['pending'];
      }
    });

    this.reloadLeadSubcribe = this.leadComunicationService.reloadLeads.subscribe(
      (reloadOrigins?: boolean) => {
        if (reloadOrigins) {
          this.originSelectionComponent.getOrigins();
        }
      }
    );

    this.customFilterSubcribe = this.leadComunicationService.customFilter.subscribe(
      (filterApplied: boolean) => {
        this.filterReminders = false;
        this.filterVisits = false;
        this.filterTransfereds = false;
        this.filterContacteds = false;
        this.visitFilterGroupActive = !filterApplied;
        this.applyFilter();
        this.drawFinished = true;
      }
    );
  }

  ngAfterViewInit(): void {
    this.phoneForm.valueChanges.subscribe(val => {

      if (val.phone !== null) {
        this.filterPhone(val);
      } else {
        this.filter.leadContact = '';
        this.checkContactFilter = true;
      }
      if (this.filter.leadContact) {
        this.checkContactFilter = this.filter.leadContact.length >= 3;
      }
    });
    setTimeout(() => {
      this.generateFilterFromLocalStorage();
      this.applyFilter();
    });
  }

  filterPhone(value) {
    if (value.phone.e164Number) {
      this.filter.leadContact = value.phone.e164Number;
    } else {
      if (value.phone.number) {
        if (value.phone.number.startsWith('+')) {
          this.filter.leadContact = value.phone.number;
        } else {
          this.filter.leadContact = value.phone.dialCode + value.phone.number;
        }
      }
    }
  }

  filterByOptionArchived(option: string): void {
    switch (option) {
      case 'not_contacted':
        this.archivedNotContacted = !this.archivedNotContacted;
        break;
      case 'not_interested':
        this.archivedNotInterested = !this.archivedNotInterested;
        break;
      case 'other':
        this.archivedOther = !this.archivedOther;
        break;
      case 'by_price':
        this.archivedByPrice = !this.archivedByPrice;
        break;
      case 'by_appraisal':
        this.archivedByAppraisal = !this.archivedByAppraisal;
        break;
      case 'by_financing':
        this.archivedByFinancing = !this.archivedByFinancing;
        break;
      case 'immature':
        this.archivedImmature = !this.archivedImmature;
        break;
      case 'samebrand':
        this.archivedSameBrand = !this.archivedSameBrand;
        break;
      case 'anotherbrand':
        this.archivedAnotherBrand = !this.archivedAnotherBrand;
        break;
      case 'samebrand_dealership':
        this.archivedSameBrandDealership = !this.archivedSameBrandDealership;
        break;
      case 'anotherbrand_dealership':
        this.archivedAnotherBrandDealership = !this.archivedAnotherBrandDealership;
        break;
      default:
        break;
    }

    if (this.archivedOther || this.archivedNotInterested || this.archivedNotContacted ||
      this.archivedByPrice || this.archivedByAppraisal || this.archivedByFinancing ||
      this.archivedImmature || this.archivedSameBrand || this.archivedAnotherBrand ||
      this.archivedSameBrandDealership || this.archivedAnotherBrandDealership) {
      this.filterArchived = true;
    } else {
      this.filterArchived = false;
      this.filter.archivedComment = '';
      this.archivedDateRange = { start: null, end: null };
    }
  }

  filterByOptionLead(option: string | null): void {
    this.phoneForm.reset();
    this.filter.leadContact = '';
    if (!option) {
      this.filter.leadContactType = undefined;
      this.checkContactFilter = true;
      this.contactFilterInputType = 'text';
      return;
    }

    if (this.filter.leadContactType === option) {
      this.filter.leadContactType = undefined;
      this.filter.leadContact = '';
      this.checkContactFilter = true;
      return;
    }

    this.filter.leadContactType = option;

    if (this.filter.leadContact.length > 0) {
      this.checkMinOfContactFilter();
    } else {
      this.checkContactFilter = true;
    }

    if (option === 'filter_by_phone') {
      this.contactFilterInputType = 'tel';
    } else {
      this.contactFilterInputType = 'text';
    }

  }

  filterByPostalCode(option: string | null): void {
    this.filter.postalCode = '';
    if (!option) {
      this.filter.postalCodeType = undefined;
      this.checkPostalCodeFilter = true;
      this.postalCodeFilterInputType = 'text';
      return;
    }

    if (this.filter.postalCodeType === option) {
      this.filter.postalCodeType = undefined;
      this.filter.postalCode = '';
      this.checkPostalCodeFilter = true;
      return;
    }

    this.filter.postalCodeType = option;

    if (this.filter.postalCode.length > 0) {
      this.checkMinOfPostalCodeFilter();
    } else {
      this.checkPostalCodeFilter = true;
    }

    if (option === 'filter_by_postal_code') {
      this.postalCodeFilterInputType = 'number';
    } else {
      this.postalCodeFilterInputType = 'text';
    }
  }

  addFilterArchived(): void {
    this.filterArchived = !this.filterArchived;
    if (this.filterArchived) {
      this.filter.status.push('archived');
    } else {
      this.removeElement('archived', this.filter.status);
      this.filter.archivedComment = '';
      this.archivedDateRange = { start: null, end: null };
    }
    if (
      this.filterArchived &&
      !this.archivedNotContacted &&
      !this.archivedNotInterested &&
      !this.archivedOther &&
      !this.archivedByPrice &&
      !this.archivedByAppraisal &&
      !this.archivedByFinancing &&
      !this.archivedImmature &&
      !this.archivedSameBrand &&
      !this.archivedAnotherBrand &&
      !this.archivedSameBrandDealership &&
      !this.archivedAnotherBrandDealership
    ) {
      this.archivedNotContacted = true;
      this.archivedNotInterested = true;
      this.archivedOther = true;
      this.archivedByPrice = true;
      this.archivedByAppraisal = true;
      this.archivedByFinancing = true;
      this.archivedImmature = true;
      this.archivedSameBrand = true;
      this.archivedAnotherBrand = true;
      this.archivedSameBrandDealership = true;
      this.archivedAnotherBrandDealership = true;
    }

    if (!this.filterArchived) {
      this.archivedNotContacted = false;
      this.archivedNotInterested = false;
      this.archivedOther = false;
      this.archivedByPrice = false;
      this.archivedByAppraisal = false;
      this.archivedByFinancing = false;
      this.archivedImmature = false;
      this.archivedSameBrand = false;
      this.archivedAnotherBrand = false;
      this.archivedSameBrandDealership = false;
      this.archivedAnotherBrandDealership = false;
    }
  }

  applyFilter(): void {
    this.sending = true;

    this.filter.user = this.userSelectionComponent
      ? this.userSelectionComponent.selectedItems.map((user) => user.id)
      : this.usersSelected || [];
    this.filter.dealer = this.dealerSelectionComponent
      ? this.dealerSelectionComponent.selectedItems.map((dealer) => dealer.id)
      : this.dealersSelected || [];

    if (this.filterName === Filter.NEW_DASHBOARD || this.filterName === Filter.DASHBOARD) {
      (this.filter as DashboardFilter).companies = this.companiesSelectionComponent
        ? this.companiesSelectionComponent.selectedItems.map((user) => user.id)
        : [];
    }

    this.filter.brand = this.brandSelectionComponent
      ? this.brandSelectionComponent.selectedItems.map((brand) => brand.id)
      : this.brandsSelected || [];
    this.filter.channel = this.channelSelectionComponent
      ? this.channelSelectionComponent.selectedItems.map(
        (channel) => channel.id
      )
      : this.channelSelected || [];

    this.filter.leadType = this.typesSelectionComponent
      ? this.typesSelectionComponent.selectedItems.map((type) => type.id)
      : this.typesSelected || [];

    this.filter.origin = this.originSelectionComponent
      ? this.originSelectionComponent.selectedItems
      : this.originSelected || [];

    this.createDateRangeForFilter();
    this.createDateUpdateRangeForFilter();
    this.visitDateRangeForFilter();
    this.reminderDateRangeForFilter();

    this.filter.visitStatus = this.visitStatus;

    this.filter.onTrack = [];
    this.filter.status = [];

    if (this.filterOnTrackCold) {
      this.filter.status.push('on_track');
      this.filter.onTrack.push('cold');
    }

    if (this.filterOnTrackWarm) {
      this.filter.status.push('on_track');
      this.filter.onTrack.push('warm');
    }

    if (this.filterOnTrackHot) {
      this.filter.status.push('on_track');
      this.filter.onTrack.push('hot');
    }

    if (this.filterNewLead) {
      this.filter.status.push('new');
    }
    this.filterClosed = false;
    this.filterArchived = false;
    this.filter.archivedOption = [];
    this.filter.archivedComment = '';
    this.filter.archivedAtFrom = null;
    this.filter.archivedAtTo = null;
    this.filter.closedComment = '';
    this.filter.closedAtFrom = null;
    this.filter.closedAtTo = null;
    if (this.filter.leadContactType === 'filter_by_phone' && this.phoneForm.get('phone').value) {
      this.filter.leadContact = this.phoneForm.get('phone').value.e164Number;
    }
    this.scoringRangeForFilter();

    this.filter.hasReminder = this.filterReminders;
    this.filter.hasVisit = this.filterVisits;
    this.filter.hasContacted = this.filterContacteds;
    this.filter.transferred = this.filterTransfereds ? 1 : 0;

    this.filter.notContacted = this.filterNotContacteds;
    this.filter.onPrequalification = this.filterPrequalification;
    this.filter.onCall = this.filterOnCall;

    this.saveFilter();

    this.leadComunicationService.applyFilter(this.filter);
    this.sending = false;
  }

  createDateRangeForFilter(): void {
    if (this.rangeCreate.start) {
      this.filter.createdAtFrom = this.rangeCreate.start;
      if (!this.rangeCreate.end) {
        this.rangeCreate.end = new Date(this.rangeCreate.start);
        this.rangeSelected = `${moment(this.rangeCreate.start).format(
          'D/M/YYYY'
        )} - ${moment(this.rangeCreate.end).format('D/M/YYYY')}`;
      }
      this.rangeCreate.end.setHours(23, 59, 59);
      this.filter.createdAtTo = this.rangeCreate.end;
    }
  }

  createDateUpdateRangeForFilter(): void {
    if (this.rangeUpdate.start) {
      this.filter.updatedAtFrom = this.rangeUpdate.start;
      if (!this.rangeUpdate.end) {
        this.rangeUpdate.end = new Date(this.rangeUpdate.start);
        this.rangeSelected = `${moment(this.rangeUpdate.start).format(
          'D/M/YYYY'
        )} - ${moment(this.rangeUpdate.end).format('D/M/YYYY')}`;
      }
      this.rangeUpdate.end.setHours(23, 59, 59);
      this.filter.updatedAtTo = this.rangeUpdate.end;
    }
  }

  visitDateRangeForFilter(): void {
    if (this.rangeVisit.start) {
      this.filter.visitDateFrom = this.rangeVisit.start;
      if (!this.rangeVisit.end) {
        this.rangeVisit.end = new Date(this.rangeVisit.start);
      }
      this.rangeVisit.end.setHours(23, 59, 59);
      this.filter.visitDateTo = this.rangeVisit.end;
    }
  }

  reminderDateRangeForFilter(): void {
    if (this.rangeReminder.start) {
      this.filter.reminderDateFrom = this.rangeReminder.start;
      if (!this.rangeReminder.end) {
        this.rangeReminder.end = new Date(this.rangeReminder.start);
      }
      this.rangeReminder.end.setHours(23, 59, 59);
      this.filter.reminderDateTo = this.rangeReminder.end;
    }
  }

  clearDateReminder(): void {
    this.filter.reminderDateFrom = null;
    this.filter.reminderDateTo = null;
    this.rangeReminder = { start: null, end: null };
  }

  clearDateVisit(): void {
    this.filterVisits = false;
    this.filter.hasVisit = false;
    this.filter.visitDateFrom = null;
    this.filter.visitDateTo = null;
    this.rangeVisit = { start: null, end: null };
  }

  saveFilter(): void {
    const dropdownsObject = {
      users: this.userSelectionComponent,
      brands: this.brandSelectionComponent,
      channels: this.channelSelectionComponent,
      dealers: this.dealerSelectionComponent,
      types: this.typesSelectionComponent,
      origins: this.originSelectionComponent
    };

    const filterStatus = {

      filterClosed: this.filterClosed,
      filterNewLead: this.filterNewLead,
      filterOnTrackHot: this.filterOnTrackHot,
      filterOnTrackWarm: this.filterOnTrackWarm,
      filterOnTrackCold: this.filterOnTrackCold,
      filterTransfereds: this.filterTransfereds,
      filterReminders: this.filterReminders,
      filterVisits: this.filterVisits,
      visitStatus: this.visitStatus,
      contactStatus: this.contactStatus,
      filterOnCall: this.filterOnCall,
      filterOnPrequalification: this.filterPrequalification,
    };

    const filterUpdateCreateRanges = {
      dateModel: this.dateModel,
      rangeSelected: this.rangeSelected,
      dateUpdateModel: this.dateUpdateModel,
      rangeUpdatedSelected: this.rangeUpdatedSelected,
    };

    const archivedFilter = {
      filterArchived: this.filterArchived,
      archivedNotContacted: this.archivedNotContacted,
      archivedNotInterested: this.archivedNotInterested,
      archivedByPrice: this.archivedByPrice,
      archivedOther: this.archivedOther,
      archivedByAppraisal: this.archivedByAppraisal,
      archivedByFinancing: this.archivedByFinancing,
      archivedImmature: this.archivedImmature,
      archivedSameBrand: this.archivedSameBrand,
      archivedAnotherBrand: this.archivedAnotherBrand,
      archivedSameBrandDealership: this.archivedSameBrandDealership,
      archivedAnotherBrandDealership: this.archivedAnotherBrandDealership,
    };

    const filterLocalStorage = new LeadsFilterLocalStorageDto();

    filterLocalStorage.generateFilter(this.filter,
      dropdownsObject,
      filterStatus,
      filterUpdateCreateRanges,
      archivedFilter,
      this.phoneForm.get('phone').value
    );

    localStorage.setItem(this.filterName, JSON.stringify(filterLocalStorage));
  }

  generateFilterFromLocalStorage(): void {
    const filterLocalStorage = JSON.parse(localStorage.getItem(this.filterName));
    if (!filterLocalStorage) {
      return;
    }

    if (this.userSelectionComponent) {
      this.userSelectionComponent.selectedItems =
        filterLocalStorage.userSelectionComponentSelectedItems;
      this.usersSelected = filterLocalStorage.userSelectionComponentSelectedItems;
    }
    if (this.brandSelectionComponent) {

      this.brandSelectionComponent.selectedItems =
        filterLocalStorage.brandSelectionComponentSelectedItems;
      this.brandsSelected =
        filterLocalStorage.brandSelectionComponentSelectedItems;
    }

    if (this.channelSelectionComponent) {
      this.channelSelectionComponent.selectedItems =
        filterLocalStorage.channelSelectionComponentSelectedItems;
      this.channelSelected =
        filterLocalStorage.channelSelectionComponentSelectedItems;
    }

    if (this.dealerSelectionComponent) {

      this.dealerSelectionComponent.selectedItems =
        filterLocalStorage.dealerSelectionComponentSelectedItems;
      this.dealersSelected =
        filterLocalStorage.dealerSelectionComponentSelectedItems;
    }

    if (this.typesSelectionComponent) {
      this.typesSelectionComponent.selectedItems =
        filterLocalStorage.typesSelectionComponentSelectedItems;
      this.typesSelected =
        filterLocalStorage.typesSelectionComponentSelectedItems;
    }

    if (this.originSelectionComponent) {
      this.originSelectionComponent.selectedItems =
        filterLocalStorage.originSelectedItem;
      this.originSelected =
        filterLocalStorage.originSelectedItem;
    }

    this.rangeUpdate = {
      start: filterLocalStorage.updatedAtFrom
        ? new Date(filterLocalStorage.updatedAtFrom)
        : null,
      end: filterLocalStorage.updatedAtTo
        ? new Date(filterLocalStorage.updatedAtTo)
        : null,
    };
    this.rangeCreate = {
      start: filterLocalStorage.createdAtFrom
        ? new Date(filterLocalStorage.createdAtFrom)
        : null,
      end: filterLocalStorage.createdAtTo
        ? new Date(filterLocalStorage.createdAtTo)
        : null,
    };
    this.rangeVisit = {
      start: filterLocalStorage.visitDateFrom
        ? new Date(filterLocalStorage.visitDateFrom)
        : null,
      end: filterLocalStorage.visitDateTo
        ? new Date(filterLocalStorage.visitDateTo)
        : null,
    };
    this.rangeReminder = {
      start: filterLocalStorage.reminderDateFrom
        ? new Date(filterLocalStorage.reminderDateFrom)
        : null,
      end: filterLocalStorage.reminderDateTo
        ? new Date(filterLocalStorage.reminderDateTo)
        : null,
    };
    this.filterArchived = filterLocalStorage.filterArchived;
    this.filterClosed = filterLocalStorage.filterClosed;
    this.filterNewLead = filterLocalStorage.filterNewLead;
    this.filterOnTrackHot = filterLocalStorage.filterOnTrackHot;
    this.filterOnTrackWarm = filterLocalStorage.filterOnTrackWarm;
    this.filterOnTrackCold = filterLocalStorage.filterOnTrackCold;
    this.filterTransfereds = filterLocalStorage.filterTransfereds;
    this.filterReminders = filterLocalStorage.filterReminders;
    this.filterVisits = filterLocalStorage.filterVisits;
    this.visitStatus = filterLocalStorage.visitStatus;

    this.dateModel = filterLocalStorage.dateModel;
    this.rangeSelected = filterLocalStorage.rangeSelected;
    this.dateUpdateModel = filterLocalStorage.dateUpdateModel;
    this.rangeUpdatedSelected = filterLocalStorage.rangeUpdatedSelected;
    this.filter.archivedComment = filterLocalStorage.archivedComment;
    this.archivedNotContacted = filterLocalStorage.archivedNotContacted;
    this.archivedNotInterested = filterLocalStorage.archivedNotInterested;
    this.archivedOther = filterLocalStorage.archivedOther;
    this.archivedByPrice = filterLocalStorage.archivedByPrice;
    this.archivedByAppraisal = filterLocalStorage.archivedByAppraisal;
    this.archivedByFinancing = filterLocalStorage.archivedByFinancing;
    this.archivedImmature = filterLocalStorage.archivedImmature;
    this.archivedSameBrand = filterLocalStorage.archivedSameBrand;
    this.archivedAnotherBrand = filterLocalStorage.archivedAnotherBrand;
    this.archivedSameBrandDealership = filterLocalStorage.archivedSameBrandDealership;
    this.archivedAnotherBrandDealership = filterLocalStorage.archivedAnotherBrandDealership;
    this.filter.descriptionModel = filterLocalStorage.descriptionModel;
    this.filter.leadContactType = filterLocalStorage.leadContactType;
    if (filterLocalStorage.leadContactType === 'filter_by_phone' && filterLocalStorage.leadContact) {
      const phoneControl = this.phoneForm.get('phone');
      setTimeout(() => {
        phoneControl.setValue(filterLocalStorage.leadContact);
      });
    }
    this.filter.leadContact = filterLocalStorage.leadContact;
    this.closeDateRange = {
      start: filterLocalStorage.closedAtFrom
        ? new Date(filterLocalStorage.closedAtFrom)
        : null,
      end: filterLocalStorage.closedAtTo
        ? new Date(filterLocalStorage.closedAtTo)
        : null,
    };
    this.filter.closedComment = filterLocalStorage.closedComment;

    this.toggleContact(filterLocalStorage.contactStatus);

    this.filterOnCall = filterLocalStorage.filterOnCall;
    this.filterPrequalification = filterLocalStorage.filterOnPrequalification;
    this.archivedDateRange = {
      start: filterLocalStorage.archivedAtFrom
        ? new Date(filterLocalStorage.archivedAtFrom)
        : null,
      end: filterLocalStorage.archivedAtTo
        ? new Date(filterLocalStorage.archivedAtTo)
        : null,
    };

    this.filter.postalCode = filterLocalStorage.postalCode;
    this.filter.postalCodeType = filterLocalStorage.postalCodeType;
    this.filter.scoring = filterLocalStorage.scoring || {};
    this.scoringFrom = this.filter.scoring.scoringFrom;
    this.scoringTo = this.filter.scoring.scoringTo;
    this.scoringNull = this.filter.scoring.scoringNull;
  }

  selectDateFilter(amount: number, filter?: any): void {
    this.rangeSelected = '';
    this.filterDate = filter;
    this.today = moment();
    const newdate = moment().subtract(amount, 'days');

    this.rangeCreate.end =
      filter === 'yesterday' ? newdate.toDate() : this.today.toDate();

    this.rangeCreate.start = newdate.toDate();
    this.rangeCreate.start.setHours(0, 0, 0);
    this.syncDatePresetSelected(filter, amount);
  }

  selectDateFilterFromDropdown(value: string): void {
    if (value === 'clear') {
      this.clearDateFilter();
      this.datePresetSelected = '';
      return;
    }

    this.dateModel = value;
    switch (value) {
      case 'today':
        this.selectDateFilter(0);
        break;
      case 'yesterday':
        this.selectDateFilter(1, 'yesterday');
        break;
      case 'week':
        this.selectDateFilter(6);
        break;
      case 'month':
        this.selectDateFilter(30);
        break;
      case 'range':
        // Solo activa el modo rango (datepicker) como en los botones
        this.dateModel = 'range';
        this.datePresetSelected = '';
        break;
      default:
        break;
    }
  }

  selectDateUpdateFilterFromDropdown(value: string): void {
    if (value === 'clear') {
      this.clearDateUpdateFilter();
      this.dateUpdatePresetSelected = '';
      return;
    }

    this.dateUpdateModel = value;
    switch (value) {
      case 'today':
        this.applyUpdateDatePreset(0);
        break;
      case 'yesterday':
        this.applyUpdateDatePreset(1, 'yesterday');
        break;
      case 'week':
        this.applyUpdateDatePreset(6);
        break;
      case 'month':
        this.applyUpdateDatePreset(30);
        break;
      case 'rangeUpdate':
        // Solo activa el modo rango (datepicker) como en los botones
        this.dateUpdateModel = 'rangeUpdate';
        this.dateUpdatePresetSelected = '';
        break;
      default:
        break;
    }
  }

  private applyUpdateDatePreset(amount: number, filter?: any): void {
    this.rangeUpdatedSelected = '';
    this.filterDateUpdate = filter;
    this.today = moment();
    const newdate = moment().subtract(amount, 'days');

    this.rangeUpdate.end =
      filter === 'yesterday' ? newdate.toDate() : this.today.toDate();

    this.rangeUpdate.start = newdate.toDate();
    this.rangeUpdate.start.setHours(0, 0, 0);
    this.syncDateUpdatePresetSelected(filter, amount);
  }

  clearDateFilter(): void {
    this.filterDate = '';
    this.rangeSelected = '';
    this.datePresetSelected = '';
    this.filter.createdAtFrom = null;
    this.filter.createdAtTo = null;
    this.dateModel = '';
    this.rangeCreate = { start: null, end: null };
  }

  clearDateUpdateFilter(): void {
    this.filterDateUpdate = '';
    this.rangeUpdatedSelected = '';
    this.dateUpdatePresetSelected = '';
    this.filter.updatedAtFrom = null;
    this.filter.updatedAtTo = null;
    this.dateUpdateModel = '';
    this.rangeUpdate = { start: null, end: null };
  }

  createdDateRangeChange(range): void {
    let endDate = '?';
    if (range.end) {
      endDate = moment(range.end).format('D/M/YYYY');
    }
    this.rangeSelected = `${moment(range.start).format(
      'D/M/YYYY'
    )} - ${endDate}`;
  }

  updatedDateRangeChange(range): void {
    let endDate = '?';
    if (range.end) {
      endDate = moment(range.end).format('D/M/YYYY');
    }
    this.rangeUpdatedSelected = `${moment(range.start).format(
      'D/M/YYYY'
    )} - ${endDate}`;
  }

  clearFilter(): void {
    this.filter = new LeadFilter();
    this.filterOnTrackCold = false;
    this.filterOnTrackHot = false;
    this.filterOnTrackWarm = false;
    this.filterNewLead = false;
    this.filterClosed = false;
    this.filterArchived = false;
    this.filterReminders = false;
    this.filterVisits = false;
    this.visitStatus = null;
    this.filterContacteds = false;
    this.filterTransfereds = false;
    this.companiesSelectionComponent = null;
    this.companySelected = [];
    this.userSelectionComponent = null;
    this.usersSelected = [];
    this.brandSelectionComponent = null;
    this.brandsSelected = [];
    this.channelSelectionComponent = null;
    this.channelSelected = [];
    this.typesSelectionComponent = null;
    this.typesSelected = [];
    this.dealerSelectionComponent = null;
    this.dealersSelected = [];
    this.originSelectionComponent = null;
    this.originSelected = [];
    this.archivedNotContacted = false;
    this.archivedNotInterested = false;
    this.archivedByPrice = false;
    this.archivedOther = false;
    this.archivedByAppraisal = false;
    this.archivedByFinancing = false;
    this.archivedImmature = false;
    this.archivedSameBrand = false;
    this.archivedAnotherBrand = false;
    this.archivedSameBrandDealership = false;
    this.archivedAnotherBrandDealership = false;
    this.filter.leadContact = '';
    this.filter.leadContactType = undefined;
    this.clearDateFilter();
    this.clearDateUpdateFilter();
    this.clearDateVisit();
    this.clearDateReminder();
    localStorage.removeItem(Filter.LEADS);
    this.checkContactFilter = true;
    this.clearDateClosed();
    this.contactStatus = '';
    this.filterNotContacteds = false;
    this.filterPrequalification = false;
    this.filterOnCall = false;
    this.clearDateArchived();
    this.leadComunicationService.cleanPagination.emit();
    this.checkPostalCodeFilter = true;
    this.filter.postalCode = '';
    this.filter.postalCodeType = undefined;
    this.clearScoring();
  }

  resetFilter(): void {
    this.clearFilter();
    this.applyFilter();
  }

  checkMinOfContactFilter() {
    if (this.filter.leadContactType === 'filter_by_phone') {
      return false;
    }
    if (this.filter.leadContactType && this.filter.leadContact.length === 0) {
      return this.checkContactFilter = true;
    }
    if (this.filter.leadContactType && this.filter.leadContact) {
      return this.checkContactFilter = !(this.filter.leadContactType && (this.filter.leadContact.length <= 2 && this.filter.leadContact.length !== 0));
    }
  }

  checkMinOfPostalCodeFilter() {
    if (this.filter.postalCodeType && this.filter.postalCode.length === 0) {
      return this.checkPostalCodeFilter = true;
    }
    if (this.filter.postalCodeType && this.filter.postalCode) {
      return this.checkPostalCodeFilter = !(this.filter.postalCodeType && (this.filter.postalCode.length <= 2 && this.filter.postalCode.length !== 0));
    }
  }

  toggleFilterClosed() {

    this.filterClosed = !this.filterClosed;
    if (this.filterClosed) {
      this.filter.status.push('closed');
    } else {
      this.removeElement('closed', this.filter.status);
      this.filter.closedComment = '';
      this.closeDateRange = { start: null, end: null };
    }
  }

  clearDateClosed(): void {
    this.filter.closedAtFrom = null;
    this.filter.closedAtTo = null;
    this.closeDateRange = { start: null, end: null };
  }

  closedDateRangeForFilter(): void {
    if (this.closeDateRange.start) {
      this.filter.closedAtFrom = this.closeDateRange.start;
      if (!this.closeDateRange.end) {
        this.closeDateRange.end = new Date(this.closeDateRange.start);
      }
      this.closeDateRange.end.setHours(23, 59, 59);
      this.filter.closedAtTo = this.closeDateRange.end;
    }
  }

  filterByNew() {
    this.filterNewLead = !this.filterNewLead;
    if (this.filterNewLead) {
      this.filter.status.push('new');
    } else {
      this.removeElement('new', this.filter.status);
    }
  }

  filterByOnTrack(option: string) {

    switch (option) {
      case 'hot':
        this.filterOnTrackHot = !this.filterOnTrackHot;
        break;
      case 'cold':
        this.filterOnTrackCold = !this.filterOnTrackCold;
        break;
      case 'warm':
        this.filterOnTrackWarm = !this.filterOnTrackWarm;
        break;
      default:
        break;
    }
    if (this.checkStateDeselected()) {
      this.removeOnTrack(this.filter.status);
    }
    if (this.checkFirstStateOnTrack()) {
      this.addFirstStateOnTrack(option);
    } else {
      this.addStateOnTrack(option);
    }
  }

  filterByVisitStatus(option: string) {

    this.visitStatus = this.visitStatus !== option ? option : null;
  }

  toggleContact(option: string) {

    if (this.contactStatus === option) {
      this.contactStatus = '';
    } else {
      this.contactStatus = option;
    }

    if (this.contactStatus === 'contacteds') {
      this.filterContacteds = true;
      this.filterNotContacteds = false;
      return;
    }
    if (this.contactStatus === 'not_contacteds') {
      this.filterContacteds = false;
      this.filterNotContacteds = true;
      return;
    }

    this.filterContacteds = false;
    this.filterNotContacteds = false;
    this.filterPrequalification = false;
  }

  clearDateArchived(): void {
    this.filter.archivedAtFrom = null;
    this.filter.archivedAtTo = null;
    this.archivedDateRange = { start: null, end: null };
  }

  clearScoring(): void {
    this.filter.scoring = {};
    this.scoringFrom = null;
    this.scoringTo = null;
    this.scoringNull = null;
  }

  toogleScoringNull() {
    this.scoringNull = !this.scoringNull;
    this.scoringFrom = null;
    this.scoringTo = null;
  }

  private isDateFilterSelected(): boolean {
    return Boolean(this.rangeCreate.end || this.rangeCreate.start);
  }

  private isDateUpdateFilterSelected(): boolean {
    return Boolean(this.rangeUpdate.end || this.rangeUpdate.start);
  }

  private isDateReminderFilterSelected(): boolean {
    return Boolean(
      this.filter.reminderDateFrom ||
      this.filter.reminderDateTo ||
      (this.rangeReminder &&
        (this.rangeReminder.start || this.rangeReminder.end))
    );
  }

  private isDateVisitFilterSelected(): boolean {
    return Boolean(
      this.filter.visitDateFrom ||
      this.filter.visitDateTo ||
      (this.rangeVisit && (this.rangeVisit.start || this.rangeVisit.end))
    );
  }

  private isStatusFilterSelected(): boolean {
    return Boolean(
      this.filterOnTrackCold || this.filterOnTrackHot || this.filterOnTrackWarm
    );
  }

  private isDropdownElementFilterSelected(): boolean {
    return Boolean(
      (this.userSelectionComponent && this.userSelectionComponent.selectedItems.length > 0) ||
      (this.typesSelectionComponent && this.typesSelectionComponent.selectedItems.length > 0) ||
      (this.dealerSelectionComponent && this.dealerSelectionComponent.selectedItems.length > 0) ||
      (this.companiesSelectionComponent && this.companiesSelectionComponent.selectedItems.length > 0) ||
      (this.brandSelectionComponent && this.brandSelectionComponent.selectedItems.length > 0) ||
      (this.channelSelectionComponent && this.channelSelectionComponent.selectedItems.length > 0) ||
      (this.typesSelectionComponent && this.typesSelectionComponent.selectedItems.length > 0) ||
      (this.originSelectionComponent && this.originSelectionComponent.selectedItems
        && this.originSelectionComponent.selectedItems.length > 0)
    );
  }

  private isDateArchivedFilterSelected(): boolean {
    return Boolean(
      this.filter.archivedAtFrom ||
      this.filter.archivedAtTo ||
      (this.archivedDateRange &&
        (this.archivedDateRange.start || this.archivedDateRange.end))
    );
  }

  private isScoringRangeFilterSelected(): boolean {
    return Boolean(
      this.scoringNull
      || this.scoringFrom
      || this.scoringTo
      || this.scoringTo === 0
      || this.scoringFrom === 0
    );
  }

  private removeElement(element: any, array: any[]) {
    const index = array.indexOf(element);
    if (index !== -1) {
      array.splice(index, 1);
    }

  }

  private isDateClosedFilterSelected(): boolean {
    return Boolean(
      this.filter.closedAtFrom ||
      this.filter.closedAtTo ||
      (this.closeDateRange &&
        (this.closeDateRange.start || this.closeDateRange.end))
    );
  }

  private removeOnTrack(arreglo: any[]) {
    const index = arreglo.indexOf('on_track');
    if (index !== -1) {
      arreglo.splice(index, 1);
    }
  }

  private generateFilterDateCreateFromMetrics(filtersData: any): void {

    if (filtersData.createdAtFrom && filtersData.createdAtTo) {
      const createdAtFrom = moment(filtersData.createdAtFrom);

      const createdAtTo = moment(filtersData.createdAtTo);
      this.createdAtTo = moment(filtersData.createdAtTo).toDate();
      this.dateModel = filtersData.filterDate;
      this.rangeSelected = filtersData.filterDate
        ? ''
        : `${createdAtFrom.format('D/M/YYYY')} - ${createdAtTo.format(
          'D/M/YYYY'
        )}`;

      this.rangeCreate = {
        start: filtersData.createdAtFrom,
        end: filtersData.createdAtTo,
      };
      if (this.dateModel === 'range') {
        this.rangeSelected = `${createdAtFrom.format(
          'D/M/YYYY'
        )} - ${createdAtTo.format('D/M/YYYY')}`;
      }
    }
  }

  private generateFilterDateUpdateFromMetrics(filtersData: any): void {
    if (filtersData.updatedAtFrom && filtersData.updatedAtTo) {
      const updatedAtFrom = moment(filtersData.updatedAtFrom);

      const updatedAtTo = moment(filtersData.updatedAtTo);
      this.updatedAtTo = moment(filtersData.updatedAtTo).toDate();
      this.dateUpdateModel = filtersData.filterDateUpdate;
      this.rangeUpdatedSelected = filtersData.filterDateUpdate
        ? ''
        : `${updatedAtFrom.format('D/M/YYYY')} - ${updatedAtTo.format(
          'D/M/YYYY'
        )}`;

      this.rangeUpdate = {
        start: filtersData.updatedAtFrom,
        end: filtersData.updatedAtTo,
      };
      if (this.dateUpdateModel === 'range') {
        this.rangeUpdatedSelected = `${updatedAtFrom.format(
          'D/M/YYYY'
        )} - ${updatedAtTo.format('D/M/YYYY')}`;
      }
    }
  }

  private archivedDateRangeForFilter(): void {
    if (this.archivedDateRange.start) {
      this.filter.archivedAtFrom = this.archivedDateRange.start;
      if (!this.archivedDateRange.end) {
        this.archivedDateRange.end = new Date(this.archivedDateRange.start);
      }
      this.archivedDateRange.end.setHours(23, 59, 59);
      this.filter.archivedAtTo = this.archivedDateRange.end;
      this.filter.archivedAtTo = this.archivedDateRange.end;
    }
  }

  private scoringRangeForFilter(): void {
    this.filter.scoring = {
      scoringNull: this.scoringNull,
      scoringTo: this.scoringTo,
      scoringFrom: this.scoringFrom,
    };
  }

  private addOrRemoveStateOnTrack(state: string) {
    const existState = this.filter.onTrack.includes(state);
    if (!existState) {
      this.filter.onTrack.push(state);
    } else {
      this.removeElement(state, this.filter.onTrack);
    }
  }

  private addStateOnTrack(state) {
    this.addOrRemoveStateOnTrack(state);
  }

  private checkStateDeselected() {
    return !this.filterOnTrackHot && !this.filterOnTrackWarm && !this.filterOnTrackCold &&
      this.filter.status.includes('on_track');
  }

  private checkFirstStateOnTrack() {
    return (this.filterOnTrackHot || this.filterOnTrackCold || this.filterOnTrackWarm) &&
      !this.filter.status.includes('on_track');
  }

  private addFirstStateOnTrack(state: string) {
    this.filter.status.push('on_track');
    this.addOrRemoveStateOnTrack(state);
  }

  private syncDatePresetSelected(filter: any, amount: number): void {
    if (filter === 'yesterday') {
      this.datePresetSelected = 'yesterday';
      return;
    }
    if (amount === 0) {
      this.datePresetSelected = 'today';
      return;
    }
    if (amount === 6) {
      this.datePresetSelected = 'week';
      return;
    }
    if (amount === 30) {
      this.datePresetSelected = 'month';
      return;
    }
    this.datePresetSelected = '';
  }

  private syncDateUpdatePresetSelected(filter: any, amount: number): void {
    if (filter === 'yesterday') {
      this.dateUpdatePresetSelected = 'yesterday';
      return;
    }
    if (amount === 0) {
      this.dateUpdatePresetSelected = 'today';
      return;
    }
    if (amount === 6) {
      this.dateUpdatePresetSelected = 'week';
      return;
    }
    if (amount === 30) {
      this.dateUpdatePresetSelected = 'month';
      return;
    }
    this.dateUpdatePresetSelected = '';
  }

  onPanelChange(event: NgbPanelChangeEvent) {
    if (event.nextState === true) {

      this.typesSelectionComponent.loadLeadTypes();
      this.userSelectionComponent.loadUsers();
    }
  }

  requestToggleView(event: Event): void {
    event.stopPropagation();
    this.leadComunicationService.requestToggleView();
  }

  requestCreateLead(event: Event): void {
    event.stopPropagation();
    this.leadComunicationService.requestCreateLead();
  }

  requestDownloadLeads(event: Event): void {
    event.stopPropagation();
    this.leadComunicationService.requestDownloadLeads();
  }

  get downloadInProgress(): boolean {
    return this.csvService.downloadInProgress;
  }

  get isDesktop(): boolean {
    return this.deviceDetector.isDesktop();
  }

  onLeadsOrderChange(): void {
    this.leadComunicationService.requestLeadsOrder(this.leadsOrderField, this.leadsOrderBy);
  }

  uploadCsv(): void {
    this.modalsHandler.openImportLeadModal();
  }  
}
